import React from 'react';
import { EMAIL } from '@/constants';
import TextLarge from '../Typography/TextLarge';
import TextSmall from '../Typography/TextSmall';

function LoginFormHeader({ type, activeTab = EMAIL, userInfo = {} }) {
  const renderHeader = () => {
    if (type === 'loginForm') {
      return (
        <>
          <TextLarge
            text="Welcome to Singer"
            className="text-lg lg:text-lg font-semibold text-coarse-wool mb-16"
          />

          <TextSmall
            text="Enjoy a personalized experience and greater savings by being part of
            the Singer family!"
            className="text-base lg:text-sm text-center font-medium text-coarse-wool lg:px-0 sm:px-[40px] mb-20 lg:mb-32"
          />
        </>
      );
    }

    if (type === 'otpForm') {
      return (
        <div className="flex flex-col gap-[16px] items-center mb-24">
          <TextLarge
            text="OTP Verification"
            className="text-lg lg:text-lg font-semibold text-senate"
          />

          <div className="flex flex-col items-center">
            <TextSmall className="text-base lg:text-sm text-center font-medium text-senate">
              Your 6 digit code has been sent
              {activeTab === EMAIL ? ' via email' : ' '} to <br />
              {activeTab === EMAIL ? '' : ' +880'}
              {userInfo}
            </TextSmall>
          </div>
        </div>
      );
    }

    if (type === 'loginFormForSpin') {
      return (
        <>
          <TextLarge
            text="Congratulations!"
            className="text-lg lg:text-lg font-semibold text-coarse-wool mb-16"
          />

          <TextSmall
            text="You have just unlocked a coupon for your next order. Log in to avail
            the coupon."
            className="text-base lg:text-sm text-center font-medium text-coarse-wool lg:px-0 sm:px-[40px] mb-20 lg:!mb-32"
          />
        </>
      );
    }
  };

  return <>{renderHeader()}</>;
}

export default LoginFormHeader;
